"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createImageAvatarStyle;

function createImageAvatarStyle(_ref) {
  var avatarSize = _ref.avatarSize;
  return {
    height: avatarSize,
    overflow: 'hidden',
    width: avatarSize
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvSW1hZ2VBdmF0YXIudHMiXSwibmFtZXMiOlsiY3JlYXRlSW1hZ2VBdmF0YXJTdHlsZSIsImF2YXRhclNpemUiLCJoZWlnaHQiLCJvdmVyZmxvdyIsIndpZHRoIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0Esc0JBQVQsT0FBb0U7QUFBQSxNQUFsQ0MsVUFBa0MsUUFBbENBLFVBQWtDO0FBQ2pGLFNBQU87QUFDTEMsSUFBQUEsTUFBTSxFQUFFRCxVQURIO0FBRUxFLElBQUFBLFFBQVEsRUFBRSxRQUZMO0FBR0xDLElBQUFBLEtBQUssRUFBRUg7QUFIRixHQUFQO0FBS0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZUltYWdlQXZhdGFyU3R5bGUoeyBhdmF0YXJTaXplIH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIGhlaWdodDogYXZhdGFyU2l6ZSxcbiAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgd2lkdGg6IGF2YXRhclNpemVcbiAgfTtcbn1cbiJdfQ==